import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const NAV_ITEMS = [
  { to: '/podrocja-dela', key: 'practiceAreas' },
  { to: '/splosni-pogoji', key: 'documents' },
  { to: '/brezplacna-pravna-pomoc', key: 'freeLegalAid' },
  { to: '/mediacija', key: 'mediation' },
  { to: '/o-nas', key: 'aboutUs' },
  { to: '/kje-smo', key: 'about' },
  { to: '/kontakt', key: 'contact' },
];

const LANGUAGES = ['sl', 'de', 'en'];

export default function Header() {
  const { language, changeLanguage, t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 24);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Po izbiri strani se meni zapre sam, sicer bi na telefonu ostal cez vsebino.
  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsMenuOpen(false);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isMenuOpen]);

  return (
    <header className={`site-header ${isScrolled ? 'is-scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="nav-row">
        <Link to="/" className="logo" aria-label={t.header.logo}>
          <span className="logo-mark">BM</span>
          <span className="logo-text">
            <span className="logo-title">BM Odvetniki</span>
            <span className="logo-subtitle">PISARNA MARTINA BREGANTA</span>
          </span>
        </Link>

        <nav id="glavna-navigacija" className="nav">
          {NAV_ITEMS.map((item) => (
            <Link key={item.to} to={item.to}>{t.header[item.key]}</Link>
          ))}
        </nav>

        <div className="lang-switcher">
          {LANGUAGES.map((lang) => (
            <button
              key={lang}
              type="button"
              className={`lang-btn ${language === lang ? 'active' : ''}`}
              onClick={() => changeLanguage(lang)}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Viden samo na telefonih (do 768px); na tablicah in racunalnikih je meni razprt. */}
        <button
          type="button"
          className="nav-toggle"
          aria-expanded={isMenuOpen}
          aria-controls="glavna-navigacija"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          {t.header.menu}
          <span className="nav-toggle-icon" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>
      </div>
    </header>
  );
}
